import * as React from "react";
import PropTypes from 'prop-types';

const SvgTrackOrder = props => {
  if (props.id !== "_svgtrackorder") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 32 32" {...props}><path fillRule="evenodd" d="M4 9.903l4 1.462v7.184l3 1.408v-7.495l4 1.462V28l-9.831-4.493A2.003 2.003 0 014 21.687V9.904zm24 0v11.785c0 .782-.457 1.493-1.169 1.819L17 28V13.924l11-4.021zm-4.495-3.29L27 7.893l-11 4.022-3.521-1.287 11.026-4.013zm-8.192-2.491c.444-.162.93-.162 1.374 0l2.441.892L8.104 9.027 5 7.892l10.313-3.77z" /></svg>;
};

SvgTrackOrder.displayName = "_svgtrackorder";
SvgTrackOrder.propTypes = {
  id: PropTypes.string
};
SvgTrackOrder.defaultProps = {
  id: ''
};
export default SvgTrackOrder;